import React from 'react';
import classNames from '../../common/classNames';

const formatType1 = '{1}:{2}:{3}';
const formatType2 = ' {1}h:{2}m:{3}s';
const formatType3 = '{0}d:{1}h:{2}m:{3}s';

const defineOutputFormat = (format) => {
    let result;
    switch (format) {
        case 'hh:mm:ss':
            result = formatType1;
            break;
        case 'dd_hh_mm_ss':
            result = formatType3;
            break;
        case 'HHh_MMm_SSs':
            result = formatType2;
            break;
        default:
            result = formatType1;
    }
    return result;
};

const calculateCountOfDays = (remainingDate) => {
    const countOfMilisecondsPerDay = 1000 * 60 * 60 * 24;
    return Math.round(remainingDate.getTime() / countOfMilisecondsPerDay);
};

export default ({ timeStamp, format, utc, className, isFinalPrize }) => {
    const date = new Date(timeStamp);
    const renderResult = (days, hours, minutes, seconds) => defineOutputFormat(format)
        .replace('{0}', days.toString().padStart(2, '0'))
        .replace('{1}', hours.toString().padStart(2, '0'))
        .replace('{2}', minutes.toString().padStart(2, '0'))
        .replace('{3}', seconds.toString().padStart(2, '0'));
    let res = '';
    utc ? res = renderResult(calculateCountOfDays(date),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()) :
        res = renderResult(calculateCountOfDays(date),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds());
    return <span className={classNames(isFinalPrize, { [className]: className })}>{res}</span>;
};

